var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40002 19.4399V20.8799C8.40002 21.2618 8.2483 21.6281 7.97825 21.8981C7.70821 22.1682 7.34193 22.3199 6.96002 22.3199C6.57811 22.3199 6.21183 22.1682 5.94179 21.8981C5.67174 21.6281 5.52002 21.2618 5.52002 20.8799V19.5504",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 19.4399V20.8799C15.6 21.2618 15.7517 21.6281 16.0217 21.8981C16.2918 22.1682 16.6581 22.3199 17.04 22.3199C17.4219 22.3199 17.7882 22.1682 18.0582 21.8981C18.3283 21.6281 18.48 21.2618 18.48 20.8799V19.4399",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19995 9.36004V6.48004C1.19995 6.09813 1.35166 5.73185 1.62172 5.46181C1.89177 5.19176 2.25804 5.04004 2.63995 5.04004H3.94496",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 9.36004V6.48004C22.8 6.09813 22.6484 5.73185 22.3783 5.46181C22.1083 5.19176 21.7419 5.04004 21.36 5.04004H20.04",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.719971H5.99996C4.93957 0.719971 4.07996 1.57958 4.07996 2.63997V17.52C4.07996 18.5804 4.93957 19.44 5.99996 19.44H18C19.0604 19.44 19.92 18.5804 19.92 17.52V2.63997C19.92 1.57958 19.0604 0.719971 18 0.719971Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.92 13.6799H4.07996",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.16 16.5601H17.04",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95996 16.5601H9.83996",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83997 3.6001H14.16",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.7bd4797efaa4bbd622570c9a7ff98347.svg";
export { ForwardRef as ReactComponent };